import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';

const styles = createStyles({
  root: {
    height: 100,
    width: 40
  }
});

type Props = WithLanguageProps &
  WithColorQueryProps &
  WithLanguageProps &
  IWithCountryProps &
  WithStyles<typeof styles>;

export const LanguageToggle: React.SFC<Props> = props => {
  if (props.country === 'global') {
    return null;
  }
  let primary = '';
  let secondary = '';
  if (!props.loading && props.data) {
    if (
      props.data.fetch.Country.Settings &&
      props.data.fetch.Country.Settings.DualLanguage !== 'yes'
    ) {
      return null;
    }
    primary =
      props.data.fetch.Country.Settings &&
      props.data.fetch.Country.Settings.PrimaryLanguage
        ? props.data.fetch.Country.Settings.PrimaryLanguage
        : '';
    secondary =
      props.data.fetch.Country.Settings &&
      props.data.fetch.Country.Settings.SecondaryLanguage
        ? props.data.fetch.Country.Settings.SecondaryLanguage
        : '';
  }
  const toggle = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) =>
    props.toggle(!e.target.checked);

  return (
    <Container>
      <Lang>{primary}</Lang>
      <div>
        <Switch checked={!props.primary} onChange={toggle} color="default" />
      </div>
      <Lang>{secondary}</Lang>
    </Container>
  );
};

const Lang = styled.span`
  text-transform: uppercase;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: -5px;
`;

export default withStyles(styles)(
  withCountry(withColorQuery(withLanguageState(LanguageToggle)))
);



// WEBPACK FOOTER //
// ./src/components/LanguageToggle/LanguageToggle.tsx